import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function analyzeUrl(url) {
  const res = await axios.post(
    `${API}/analyze-url`,
    { url },
    { timeout: 5 * 60 * 1000 },
  );
  return res.data;
}
